module.exports = __webpack_public_path__ + "img/icon-home-app.5949759d.svg";